import react, { useContext } from 'react';

const NavIdContext = react.createContext<string[]>([]);

export const useParentNavIds = (): string[] => useContext(NavIdContext);

export default NavIdContext;
